import { C1EmptyIndicator } from 'components/core/empty-indicator/C1EmptyIndicator'
import { EmptyList } from 'components/core/empty-list'
import List from 'components/core/list'
import { C1TableReduxColumn } from 'components/core/list/C1Table/C1TableRedux'
import { C1TableReduxHook } from 'components/core/list/C1Table/C1TableReduxHook'
import { RelativeTimestamp } from 'components/core/time/display'
import { C1EntitlementDisplayNameWithFetch } from 'components/pages/entitlement/display-name'
import { AppEntitlementUserBindingHistoryValue } from 'lib/actions/apps/app-entitlement'
import { AppEntitlementWithExpired } from 'pbts/c1/api/app/v1/app_entitlement'
import { SearchPastGrantsRequest } from 'pbts/c1/api/app/v1/app_entitlement_user_binding'
import { AppUserRef } from 'pbts/c1/api/app/v1/app_user'
import React, { FC, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { searchPastGrantsApi } from 'redux_toolkit/entitlements'

const cols: C1TableReduxColumn<AppEntitlementUserBindingHistoryValue>[] = [
    {
        field: 'entitlement',
        flex: 2,
        label: <FormattedMessage defaultMessage="Entitlement" id="components_past_grants_entitlement" />,
        Component: ({ row: grant }) => (grant.appEntitlementId && grant.appId
            ? <C1EntitlementDisplayNameWithFetch entitlementId={grant.appEntitlementId} appId={grant.appId} />
            : <C1EmptyIndicator />),
    },
    {
        field: 'discovered',
        label: <FormattedMessage defaultMessage="Granted" id="components_past_grants_granted" />,
        Component: ({ row: grant }) => (
            grant.grantedAt
                ? <RelativeTimestamp date={grant.grantedAt} variant="date" />
                : <C1EmptyIndicator />
        ),
    },
    {
        field: 'expires',
        label: <FormattedMessage defaultMessage="Expired" id="components_past_grants_expired" />,
        Component: ({ row: grant }) => (
            grant.revokedAt
                ? <RelativeTimestamp date={grant.revokedAt} variant="date" />
                : <C1EmptyIndicator />
        ),
    },
]

type AppUserPastGrantsProps = {
    appId: string,
    appUserId: string,
}

export const AppUserPastGrants: FC<AppUserPastGrantsProps> = ({
    appId,
    appUserId,
}) => {
    const table = useMemo(() => {
        return <C1TableReduxHook<SearchPastGrantsRequest, AppEntitlementUserBindingHistoryValue>
            cols={cols}
            request={SearchPastGrantsRequest.create({
                appUserRefs: [AppUserRef.create({ appId, id: appUserId })],
            })}
            hook={searchPastGrantsApi.useSearchPastGrants}
            invalidateHook={searchPastGrantsApi.useInvalidateSearchPastGrants}
            emptyState={<EmptyList
                text={<FormattedMessage
                    id="components_past_grants"
                    defaultMessage="No past grants"
                />}
            />}
        />
    }, [appId, appUserId])

    return <List<AppEntitlementWithExpired> table={table} />
}
